// Retained source audio vocabulary (TT-1190): the settings switches, the
// start-modal override and the doc page's audio panel read it from here.
import dayjs from "dayjs";
import { formatElapsed } from "../services/utilities";

// Mirrors the platform's source_class values (TT-1187). The server refuses an
// unknown class, so this list is the whole set; keep it in sync.
export const SOURCE_CLASSES = [
  { key: "meeting", label: "Meetings" },
  { key: "youtube", label: "YouTube & video links" },
  { key: "spaces", label: "X Spaces" },
  { key: "upload", label: "Uploaded audio" },
];

// The settings endpoint always answers with every class as a boolean; anything
// else is a response this UI must not render switches from.
export const isClassMap = (classes) =>
  !!classes && typeof classes === "object" && SOURCE_CLASSES.every(({ key }) => typeof classes[key] === "boolean");

// How the bytes reached us (source_audio.origin).
const ORIGIN_LABELS = {
  tee: "Live capture",
  producer: "Source download",
  transcribe: "Transcription download",
  upload: "Upload",
  zoom_cloud: "Zoom cloud recording",
  recall: "Recall notetaker",
};

const MISSING = "—";
const BYTE_UNITS = ["KB", "MB", "GB", "TB"];

const isCount = (value) => typeof value === "number" && Number.isFinite(value) && value >= 0;

// The unit is chosen after rounding, so 1023.97 KB reads "1.0 MB" and 9.97 MB
// reads "10 MB": one decimal only below ten.
export function formatBytes(bytes) {
  if (!isCount(bytes)) return MISSING;
  if (Math.round(bytes) < 1024) return `${Math.round(bytes)} B`;
  let value = bytes / 1024;
  let unit = 0;
  while (Math.round(value) >= 1024 && unit < BYTE_UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  const tenths = Math.round(value * 10) / 10;
  return `${tenths < 10 ? tenths.toFixed(1) : Math.round(value)} ${BYTE_UNITS[unit]}`;
}

export const formatDuration = (seconds) => (isCount(seconds) ? formatElapsed(Math.round(seconds)) : MISSING);

export const originLabel = (origin) => ORIGIN_LABELS[origin] || origin || MISSING;

export function formatRetainedAt(iso) {
  const when = iso ? dayjs(iso) : null;
  return when?.isValid() ? when.format("MMM D, YYYY") : MISSING;
}

// What a refused DELETE …/source-audio means to the user. 409: retention is
// still working on this doc's audio (TT-1187).
export const audioDeleteFailureMessage = (status) =>
  status === 409 ? "The audio is still being processed. Try again in a moment." : "Unable to delete the audio";
